const baseURL = 'project';

export const projectPages = {
	root: { base: (): string => { return '';}, url: baseURL },

	dashboard: { base: (): string => { return `/${baseURL}`; }, url: '' },

	create: { base: (): string => { return `/${baseURL}/create`; }, url: 'create' },

	edit: { base: (projectId:string): string => { return `/${baseURL}/edit/${projectId}`; }, url: 'edit/:project_id' },
};
